export const renderPrice = (
  value: number,
  currency: string,
  thousandSeparator: string,
) => {
  const priceValue = value
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
  return `${priceValue} ${currency}`;
};
